export default {
    data() {
        return {
            pageConfig: {
                title: '',
                breadcrumb: [],
                status: null,
                code: null,
                infoCards: [],
                loading: false
            }
        };
    },

    computed: {
        pageTitle() {
            return this.pageConfig.title || this.$route.meta?this.$route.meta.title : 'Page';
        },
        pageBreadcrumb() {
            return this.pageConfig.breadcrumb || this.$route.meta? this.$route.meta.breadcrumb : [];
        },
        pageStatus() {
            return this.pageConfig.status || null;
        },
        pageCode() {
            return this.pageConfig.code || null;
        },
        pageInfoCards() {
            return this.pageConfig.infoCards || [];
        }
    },

    methods: {
        setPageTitle(title) {
            this.pageConfig.title = title;
        },
        setPageBreadcrumb(breadcrumb) {
            this.pageConfig.breadcrumb = breadcrumb;
        },
        setPageStatus(status) {
            this.pageConfig.status = status;
        },
        setPageCode(code) {
            this.pageConfig.code = code;
        },
        setPageInfoCards(cards) {
            this.pageConfig.infoCards = cards;
        },
        updatePageConfig(config) {
            this.pageConfig = { ...this.pageConfig, ...config };
        }
    }
};